module.exports = __webpack_public_path__ + "img/user-icon.8924548d.png";